import type { ApiWallpaper } from '../api/types';

import { isPatternWallpaperMimeType } from './wallpaperPattern';

export function isWallpaperPattern(
  wallpaper: Pick<ApiWallpaper, 'isPattern' | 'document'> | undefined,
) {
  return Boolean(
    wallpaper && (wallpaper.isPattern || isPatternWallpaperMimeType(wallpaper.document.mimeType)),
  );
}

export function isWallpaperBlurSupported(
  wallpaper: Pick<ApiWallpaper, 'isNoFile' | 'isPattern' | 'document'> | undefined,
) {
  return Boolean(
    wallpaper && !wallpaper.isNoFile && !isWallpaperPattern(wallpaper),
  );
}
